module.exports = __webpack_public_path__ + "static/media/relief.f0ee1d54.jpg";